import { zodResolver } from "@hookform/resolvers/zod";
import { FieldValues, Resolver } from "react-hook-form";
import { z } from "zod";

const createZodResolver = zodResolver as unknown as (schema: z.ZodTypeAny) => Resolver<FieldValues>;

/**
 * Adapts zodResolver to the concrete react-hook-form field type declared by the caller.
 */
export function typedZodResolver<TFieldValues extends FieldValues>(
    schema: z.ZodTypeAny,
): Resolver<TFieldValues> {
    return createZodResolver(schema) as Resolver<TFieldValues>;
}
